<template>
    <div>
        <div class="row">
            <div class="col">
                <h5>Please enter passenger details</h5>
                <hr>
            </div>
        </div>
        <div class="row my-2">
            <app-passenger :ref="passenger.passengerId" 
                v-for="(passenger, index) in passengers" 
                v-model="passengers[index]"
                :key="passenger.passengerId"></app-passenger>
        </div>
        <div class="row my-4 justify-content-end">
            <button class="btn btn-info mx-1" @click="prevStep">Previous</button>
            <button class="btn btn-success mx-1" @click="nextStep">Next</button>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { isNullOrWhiteSpace } from '../../utils/string.js';
import appPassenger from '../passengers/Passenger.vue';

export default {
    computed: { 
        ...mapState({
            noOfAdults: state => state.passengers.noOfAdults,
            noOfChildren: state => state.passengers.noOfChildren,
            noOfInfants: state => state.passengers.noOfInfants,
            passengers: state => state.passengers.passengers,
        }),
    },
    methods: { 
        ...mapActions([ 'prevStep' ]),
        validate() {
            // loop through all passenger refs, validate and touch to give feedback if necessary 
            let valid = true;
            for (let i = 0; i < this.passengers.length; i++) {
                let passenger = this.passengers[i];
                let passengerRef = this.$refs[passenger.passengerId][0];

                if (passengerRef.$v.$invalid) {
                    passengerRef.$v.$touch();
                    valid = false;
                }
            }

            return valid;
        },
        nextStep() {
            if (this.validate()) {
                this.$store.dispatch('nextStep');
            }
        }
    },
    components: { 
        appPassenger
    },
    created() { 
        this.$store.dispatch('initPassengers');
    }
}
</script>